// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DmX5","toggle":"styles_toggle__13HJ2","preview":"styles_preview__1IzZe"};